<div class="vc-modal__innerContainer">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="visuallyhidden" i18n="@@MODAL.BUTTON.CLOSE">Close</span>
    <vc-sprite-icons class="vc-modal__closeBtn__cross" name="cross-x-thick"></vc-sprite-icons>
  </button>
  <div
    *ngIf="data && data.product && data.product.inStock"
    class="vc-modal__title localisationModal__title"
    i18n="@@PRODUCT.DETAILS.LOCALISATION.KNOW_MORE_MODAL.TITLE_IN_STOCK"
  >
    Item's location
  </div>
  <div
    *ngIf="data && data.product && !data.product.inStock"
    class="vc-modal__title localisationModal__title"
    i18n="@@PRODUCT.DETAILS.LOCALISATION.KNOW_MORE_MODAL.TITLE_OUT_STOCK"
  >
    Item's location
  </div>
  <div class="localisationModal__content">
    <ng-container *ngIf="isSustainable">
      <div class="localisationModal__subtitle localisationModal__subtitle--leaf vc-text-m">
        <vc-sprite-icons class="localisationModal__subtitle__icon" name="sustainable-leaf"></vc-sprite-icons>
        <span i18n="@@PDP_DS_MODAL.SUSTAINABLE_LEAF.TITLE">Sustainable</span>
      </div>
      <p class="localisationModal__text" i18n="@@PDP_DS_MODAL.SUSTAINABLE_LEAF.TEXT">
        Buying an item near you means reduced shipping distance and CO2.
      </p>
    </ng-container>
    <p i18n="@@PRODUCT.DETAILS.LOCALISATION.KNOW_MORE_MODAL.CONTENT">
      Once purchased: <br />
      - If the item is located with the seller, it will be sent by the seller to Vestiaire Collective to be
      authenticated. Once verified, it will be sent to you by Vestiaire Collective.<br />
      - If the item is at Vestiaire Collective, that means it has already been authenticated by our team of experts.
      <br />
      - If the article is already at Vestiaire Collective, it has already been received and checked by our team of
      experts.
    </p>
  </div>
</div>
